module.exports = __webpack_public_path__ + "static/assets/01d8922f1700d93c0ed81b2ea02fd6a0.svg";